import StudentApp from './component';
import _routes from './routes';

export const routes = _routes;

export default StudentApp;



// WEBPACK FOOTER //
// ./containers/Group/Homework/StudentApp/index.jsx